/* eslint-disable prettier/prettier */
/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable import/order */
import { FC } from 'react';
import { TableCell, TableRow } from '@mui/material';
import { Span } from 'libs/common-components/src';
import { ManageBaseDataKeys } from '@bvi/api-interfaces/entity/manage-base';
import { ManageActionMenu } from '@bvi/admin-panel/feature/manage-list/ui/manage-action-menu';
import { IManageBaseTableRowProperties } from './types';
import { styles } from './styles';

const formatCount = (value?: number) =>
  new Intl.NumberFormat('en-US').format(value ?? 0);

const formatAverage = (value?: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(value ?? 0);

export const ManageBaseTableRow: FC<IManageBaseTableRowProperties & { tabValue: ManageBaseDataKeys }> = ({
  manageBase,
  tabValue,
  ...properties
}) => {
  return (
    <TableRow {...properties}>
      <TableCell>
        <Span sx={styles.tooltipContent}>{manageBase.id}</Span>
      </TableCell>
      <TableCell>
        <Span sx={styles.tooltipContent}>{manageBase.name}</Span>
      </TableCell>
      <TableCell>
        <Span sx={styles.tooltipContent}>{formatCount(manageBase.caseCount)}</Span>
      </TableCell>
      <TableCell>
        <Span sx={styles.tooltipContent}>
          {formatCount(manageBase.claimantCount)}
        </Span>
      </TableCell>
      <TableCell>
        <Span sx={styles.tooltipContent}>
          {formatAverage(manageBase.averageSettlement)}
        </Span>
      </TableCell>
      <TableCell>
        <ManageActionMenu
          id={manageBase.id}
          detail={manageBase}
          type={tabValue}
        />
      </TableCell>
    </TableRow>
  );
};
